import React from 'react';
import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import {
  InfoCircleOutlined,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { Col, Row, Table, Typography } from 'antd';
import { Link, Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import usePremisions from '../usePremisions';
import DeleteModal from 'components/deleteModalView';
import EditModal from '../edit';
import { DeleteIcon } from '../../../../../../icons';
import EditModelModal from './editModelModal';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../../hooks/useUser';

const EditModelPage = () => {
  const { t } = useTranslation();

  const {
    loading,
    updateInProcess,
    onChangeTableFilter,
    handleDeleteCategory,
    form,
    singleItem,
    premisionsModels,
    hadnleCreatePremission,
    columnsEditModel,
    handleSetValues,
    handleDeleteModelById,
  } = usePremisions(true);
  const pages = useRecoilValue(getPage);
  return (
    <div>
      <PageHeader title={singleItem?.title}>
        {pages?.ability?.can_create && (
          <Link to={'new'}>
            <Button width={'191px'} big icon={<PlusOutlined />}>
              {t('Nuovo modulo')}
            </Button>
          </Link>
        )}
      </PageHeader>
      <div className={styles.container}>
        {singleItem.groups?.map((i) => {
          return (
            <React.Fragment>
              <Typography.Title level={3}>{i.title}</Typography.Title>
              <Table
                columns={columnsEditModel}
                dataSource={i.permissions}
                pagination={{
                  pageSize: 300,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                onChange={onChangeTableFilter}
                loading={loading}
              />
              <br />
            </React.Fragment>
          );
        })}
      </div>
      <Routes>
        <Route
          path={'new'}
          element={
            <EditModelModal
              hadnleCreatePremission={hadnleCreatePremission}
              form={form}
              onClickDelete={handleDeleteCategory}
              loading={updateInProcess}
              premisionsModels={premisionsModels}
            />
          }
        />
        <Route
          path={':idModel/edit'}
          element={
            <EditModelModal
              isEdit
              handleSetValues={handleSetValues}
              hadnleCreatePremission={hadnleCreatePremission}
              form={form}
              onClickDelete={handleDeleteCategory}
              loading={updateInProcess}
              premisionsModels={premisionsModels}
            />
          }
        />
        <Route
          path={':id/delete'}
          element={
            <DeleteModal
              onClickDelete={handleDeleteModelById}
              loading={updateInProcess}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default EditModelPage;
